var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationStationBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 20) scale(0.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 25,
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 110 L120 140 H80 Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 8,
    strokeLinecap: "round",
    d: "M70 60 A40 40 0 0 1 130 60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 6,
    strokeLinecap: "round",
    d: "M60 45 A60 60 0 0 1 140 45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 4,
    strokeLinecap: "round",
    d: "M50 30 A80 80 0 0 1 150 30"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 130,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 96
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#FF6B6B"
  }, "Location"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#4A90E2",
    dx: 0
  }, "Station")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationStationBanner);
export default __webpack_public_path__ + "static/media/location-station-banner.426a189185231846e430d7c6268b0769.svg";
export { ForwardRef as ReactComponent };